// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"196":"99dffb35","578":"07126b5a","579":"84227b1f","583":"19ab394d"}[chunkId] + ".chunk.js");